import { FullWidthWhiteBox } from '@/src/modules/account/AccountStyledComponents'
import { ReactNode, useState } from 'react'
import { ITextColumns } from '@/src/modules/account/received/GiftInfoBox'
import { styled } from '@/src/stitches.config'
import Button from '../../../common/components/marketing/buttons/Button'

const ItemWrapper = styled('div', {
    width: '100%',
    display: 'flex',
    fd: 'row',
    '.column1': {
        fontWeight: 'bold',
    },
    '.column2': {
        textAlign: 'right',
    },
    '.capitalize': {
        textTransform: 'capitalize',
    },
    '.margin-top-20': {
        mt: 20,
    },
    'gift-id-label': {
        width: 'max-content',
        whiteSpace: 'nowrap',
        marginRight: 25,
    },
    '@media (min-width:660px)': {
        gap: 20,
        jc: 'space-between',
    },
    '& p': {
        width: '-webkit-fill-available',
        fontSize: '.85rem',
        m: 0,
        pb: 10,
        '@lg': {
            fontSize: '1rem',
        },
    },
})

const ButtonWrapper = styled('div', {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
})

interface IBase {
    columnItems: ITextColumns
    giftId?: string
    children?: ReactNode
    refetchGift?: Function
}

const GiftBaseInfo = ({
    columnItems,
    giftId = '',
    children,
    refetchGift,
}: IBase) => {
    const [refetchIsLoading, setRefetchIsLoading] = useState<boolean>(false)

    function refetchGiftDetails() {
        if (refetchGift) {
            setRefetchIsLoading(true)
            refetchGift()
            setRefetchIsLoading(false)
        }
    }

    return (
        <FullWidthWhiteBox>
            {columnItems?.items?.map((item) => {
                const { column1, column2 } = item

                if (column1 && column2) {
                    return (
                        <ItemWrapper key={item.column1}>
                            <p className={'column1'}>{column1}</p>
                            <p className={'column2 capitalize'}>{column2}</p>
                        </ItemWrapper>
                    )
                }
                return
            })}
            {!!giftId && (
                <ItemWrapper>
                    <p
                        className={'column1 gift-id-label margin-top-20'}
                        style={{
                            width: 'max-content',
                            whiteSpace: 'nowrap',
                            marginRight: 25,
                        }}
                    >
                        Gift ID
                    </p>
                    <p
                        className={'column2 margin-top-20'}
                        style={{ overflowWrap: 'anywhere' }}
                    >
                        #{giftId}
                    </p>
                </ItemWrapper>
            )}
            {refetchGift && (
                <ButtonWrapper>
                    <Button
                        label={'refresh gift'}
                        textTransform={'uppercase'}
                        variant={'primary'}
                        width={'standard'}
                        showArrow={false}
                        size={'sm'}
                        style={{ marginTop: 25, width: 300 }}
                        onClick={() => refetchGiftDetails()}
                        isLoading={refetchIsLoading}
                        disabled={refetchIsLoading}
                    />
                </ButtonWrapper>
            )}
            {children}
        </FullWidthWhiteBox>
    )
}
export default GiftBaseInfo
